import { Flex } from '@chakra-ui/react';

import { ImageDescriptor, UserActivity } from '@app/api/models';
import { FieldView, Txt } from '@app/components/common';
import { TableColumn, dateTimeBodyRender, entityBaseBodyRender } from '@app/components/common/table';
import GalleryModal from '@app/components/common/modals/gallery';

export const useColumns = (): TableColumn<UserActivity>[] => {
  return [
    {
      name: 'visit_dt',
      label: 'Дата/время',
      options: {
        filter: false,
        sort: true,
        customBodyRender: dateTimeBodyRender(false, false),
      },
    },
    {
      name: 'visit_type',
      label: 'Тип активности',
      options: {
        filter: false,
        sort: true,
        customBodyRender: entityBaseBodyRender(false),
      },
    },
    {
      name: 'outlet',
      label: 'Торговая точка',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (outlet: EntityBase & { outlet_name: string }) => {
          return <Flex gap={2}>
            <Txt color='gray.500'>[{outlet.id}]</Txt>
            <Txt color='brand.500'>{outlet.outlet_name || outlet.name}</Txt>
          </Flex>;
        },
      },
    },
    {
      name: 'full_address',
      label: 'Адрес',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (address) => (
          <>
            <Txt wordBreak='normal' minW={250} whiteSpace='break-spaces'>{address || ''}</Txt>
          </>
        ),
      },
    },
    {
      name: 'data',
      label: 'Данные об оборудовании',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => {
          return <Flex gap={4} alignItems='flex-end' flexWrap='wrap' flexDirection='row' > 
            {rowData.data.equip && <>
              <FieldView 
                title="Холодильное оборудование"
                value={rowData.data.equip.model?.name || 'не определен'}                
                noPB
              />
              <FieldView 
                title="Инвентарный номер"
                value={rowData.data.equip.inventory_num}
                noPB
              />
              <FieldView 
                title="Серийный номер"
                value={rowData.data.equip.serial_num}
                noPB
              />
            </>}
            {rowData.data.stand && <>
              <Txt color='brand.500'>{rowData.data.stand.model?.name || 'не определен'}</Txt>
            </>}
          </Flex>;
        }
      },
    },
    {
      name: 'images',
      label: '',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: Array<ImageDescriptor> | undefined) => {
          return <GalleryModal images={value || []} title="Фото" />;
        },
      },
    },
  ];
};